import Vue from 'vue'

const state = {
  questionario: [],
  questionarios: [],
  questionarioEditar: [],
  questionarioResponder: [],
  respostas: [],
  questionarioVisualizar: [],
  envio: [],
  status: [],
  ipValid: []

}

const getters = {
  getQuestionario: state => {
    return state.questionario
  }
}

const mutations = {
  setQuestionario (state, data) {
    state.questionario = data
  },
  setQuestionarios (state, data) {
    state.questionarios = data
  },
  setQuestionarioEditar (state, data) {
    state.questionarioEditar = data
  },
  setQuestionarioResponder (state, data) {
    state.questionarioResponder = data
  },
  setRespostas (state, data) {
    state.respostas = data
  },
  setEnvio (state, data) {
    state.envio = data
  },
  setStatus (state, data) {
    state.status = data
  },
  setIpValid (state, data) {
    state.ipValid = data
  }
}

const actions = {
  getQuestionarios (context, config) {
    if (!config.page) {
      config.page = 1
    }

    if (!config.limit) {
      config.limit = 200
    }

    Vue.http.get('api/questionarios?length=' + config.limit + '&page=' + config.page).then(response => {
      context.commit('setQuestionarios', response.body.data.data)
    })
  },
  getQuestionario (context, id) {
    Vue.http.get('api/questionario/' + id).then(response => {
      context.commit('setQuestionarioEditar', response.data.data[0])
    })
  },
  getQuestionarioResponder (context, token) {
    Vue.http.get('api/questionario/responder/' + token).then(response => {
      if (response.data.data[0].status === 'reenviado') {
        context.commit('setQuestionarioResponder', response.data.data[0].questionario.envio.questionario)
        context.commit('setRespostas', response.data.data[0].questionario)
      } else {
        context.commit('setQuestionarioResponder', response.data.data[0].questionario)
      }
      context.commit('setEnvio', response.data.data[0].envio)
      context.commit('setStatus', response.data.data[0].status)
    })
  },
  getValidacaoIp (context, dados) {
    Vue.http.get('api/questionario/validaIp/' + dados[0] + '/' + dados[1]).then(response => {
      context.commit('setIpValid', response.data.data[0])
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/questionario.js